import { ENDPOINTS } from "../config/endpoints";

export const tournamentSchema = {
  steps: [
    {
      title: "Tournament Details",
      fields: [
        {
          name: "name",
          type: "text",
          displayName: "Tournament Name",
        },
        {
          name: "short_name",
          type: "text",
          displayName: "Short Name",
        },
        {
          name: "tournament_type",
          type: "select",
          displayName: "Tournament Type",
          optionsKey: "TOURNAMENT_TYPES",
        },
        {
          name: "match_types",
          type: "multiselect",
          displayName: "Formats",
          fetch: ENDPOINTS.matches.matchTypes,
        },
        {
          name: "folder",
          type: "select",
          displayName: "Folder (optional)",
          fetch: ENDPOINTS.competitions.tournamentFolders,
        },
        {
          name: "nationality",
          type: "select",
          displayName: "Nationality",
          fetch: ENDPOINTS.coredata.nationalities,
        },
        {
          name: "established_year",
          type: "text",
          inputType: "number",
          displayName: "Established Year",
        },
        {
          name: "end_year",
          type: "text",
          inputType: "number",
          displayName: "End Year",
        },
      ],
    },
  ],
};
